import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { Lead, LeadStatus } from 'models/Leads';

export const selectionLead = {
  status: LeadStatus.ON_HOLD,
  affiliate: IntegrationEnum.HOSTFULLY,
} as Lead;
